import {ReactNode, useEffect} from 'react';
import {useLocation} from 'react-router-dom';

import useScrollBlock from '@/shared/hooks/useScrollBlock';
import {useStatusBarDimmedColor} from '@/shared/hooks/useStatusBarDimmedColor';

type Props = {
  isOpen: boolean;
  type?: string;
  children: ReactNode;
  closePopup: () => void;
};

const Popup = ({isOpen, type, children, closePopup}: Props) => {
  const location = useLocation();

  useStatusBarDimmedColor(isOpen);
  useEffect(() => closePopup(), [location]);
  useScrollBlock(isOpen);

  if (!isOpen || !type) return null;

  return <>{children}</>;
};

export default Popup;
